import {Cookies} from "core";
import UrlBuilder from "tools/urlBuilder";

const root = '/kpi';

export function getDescriptions(){
	return [
		{
			jspUrl: 'include/Kpi/View.jsp',
			url: root,
			bodyCssClass: 'cw_kpi_module',
			getModuleImport: () => import('./kpi'),
			routeId: 'kpi'
		},
		{
			jspUrl: 'include/Kpi/Details.jsp',
			url: root + '/:id',
			bodyCssClass: 'cw_kpi_module',
			getModuleImport: () => import('./details'),
			routeId: 'kpi_details'
		}
	];
}

export class KpiRouter {
	static list() {
		return root
	}

	static details(kpiId) {
		return root + '/' + kpiId
	}

	static createNew() {
		return root + '/new';
	}
}
